import React, { PureComponent, Fragment } from 'react';
import classnames from 'classnames';
import Slider from 'react-slick';

import Icon from '~/core/scripts/components/Icon';
import slides from '~/kits/general/scripts/config';

import './ElectionAnalysis.styl';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const sliderOptions = {
  adaptiveHeight: true,
  dots: false,
  arrows: false,
  infinite: true
};

const htmlClassList = document.querySelector('html').classList;


class ElectionAnalysis extends PureComponent {
  state = {
    activeIndex: 0,
    sliderUsed: false
  }

  constructor() {
    super();

    this.lastActiveSlide = 0;
    htmlClassList.add(`active-slide-0`);
  }

  componentDidMount() {
    // for dev only
    if (this.state.activeIndex !== 0) {
      this.slider.slickGoTo(this.state.activeIndex);
    }
  }

  handleSlideChange = activeIndex => {
    this.setState({ activeIndex, sliderUsed: true });

    htmlClassList.remove(`active-slide-${this.lastActiveSlide}`);
    this.lastActiveSlide = activeIndex;
    htmlClassList.add(`active-slide-${activeIndex}`);
  }

  nextSlide() {
    this.slider.slickNext();
  }

  prevSlide() {
    this.slider.slickPrev();
  }

  render() {
    const sliderControlClasses = classnames('slider-controls', `active-slide-${this.state.activeIndex}`)

    return (
      <Fragment>
        <Slider
          className="analysis"
          ref={slider => (this.slider = slider)}
          afterChange={this.handleSlideChange}
          {...sliderOptions}
        >
          {slides.map((d, i) => {
            const SlideComp = d.comp;

            return (
              <SlideComp
                key={d.name}
                isActive={this.state.activeIndex === i}
                {...d}
              />
            );
          })}
        </Slider>
        <div className={sliderControlClasses}>
          <div className="slider-controls__prev" onClick={() => this.prevSlide()} style={{ opacity:+this.state.sliderUsed}}>
            <Icon type="arrow-left"/>
          </div>
          <div className="slider-controls__title">
            <div className="slider-controls__title-text">{slides[this.state.activeIndex].name}</div>
            <div className="slider-controls__title-dots">
              {slides.map((s, i) => (
                <div
                  className={
                    classnames(
                      'slider-controls__title-dot',
                      { 'is-active': i === this.state.activeIndex, 'is-seen': i < this.state.activeIndex }
                    )
                  }
                  key={s.name}
                />
              ))}
            </div>
          </div>
          <div className="slider-controls__next" onClick={() => this.nextSlide()}>
            <Icon type="arrow-left"/>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ElectionAnalysis;
